<router-outlet />
<p-toast data-test="toast" key="hq" position="bottom-center" />
<p-confirm-dialog [style]="{ width: '90vw', maxWidth: '36rem' }" />
